<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">

   <div class="row" style="margin: 0px;padding: 0px;">

    <div class="text-center col-sm-12" style="background-color: #337ab7;max-width: 98% !important;">
      <h2 style="color: white; text-align: center;">{{pageTitle}} Units</h2>
    </div>

    <div id="closeBtn">
      <mat-icon aria-hidden="false" class="fa-2x"  style="width: 100%; color: black;"
      id="closeBtn" (click)="onNoClick()">close</mat-icon>
    </div>

    <div class="col-sm-12">
      <div style="max-height:75vh;overflow-y:auto;">
        <div>
          <mat-form-field class="col-sm-12">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
          </mat-form-field>
        </div>

        <h3 style="color: blue; font-weight: bold;">{{message}}</h3>

        <div style="display: inline-block;" *ngIf="adminAuthorization">

          <button class="btn btn2" style="background-color: #ffc107;"
          *ngIf="!globalProcessingFlag"
           (click)="openDialog()">{{monitorOrProvision.toLowerCase()}} All Units</button>

          <mat-spinner strokeWidth="3" [diameter]="20" *ngIf="globalProcessingFlag"></mat-spinner>

        </div>

        <table mat-table [dataSource]="logsTableData"
                  class="mat-elevation-z8 col-sm-12">

          <ng-container matColumnDef="provisionIcon" >
            <td mat-cell *matCellDef="let element;" class="col-sm-1">
              <div style="display: inline-block;">
                <mat-icon aria-hidden="false" >tablet_android</mat-icon>
              </div>
          </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <td mat-cell *matCellDef="let element;" class="col-sm-10">
                <h6 class="message-box">{{element.system_name}}</h6>
                <h6 class="message-box"><span style="color: blue;font-weight: bold">IP:</span> {{element.system_ip}}</h6>
                <h6 class="message-box"><span style="color: blue;font-weight: bold">Parent Folder: </span>{{element.parentFolder}}</h6>
            </td>
          </ng-container>

          <ng-container matColumnDef="action" >
            <td mat-cell *matCellDef="let element;" class="col-sm-1">
              <div style="display: inline-block;" *ngIf="adminAuthorization">

                <button class="btn btn2" style="background-color: #ffc107;"
                *ngIf="!element.processingFlag && !element.resultSuccessFlag&& !element.resultFailedFlag"
                 (click)="sendAppropriateRequest(element)">{{monitorOrProvision.toLowerCase()}}</button>

                <mat-spinner strokeWidth="3" [diameter]="20" *ngIf="element.processingFlag"></mat-spinner>

                <mat-icon aria-hidden="false" aria-label="check_circle"
                matTooltip="Success" style="color: green;"
                *ngIf="element.resultSuccessFlag">check_circle</mat-icon>
                <span  style="color: green; font-size: 10px;"
                *ngIf="element.resultSuccessFlag"> Done</span>

                <mat-icon aria-hidden="false" aria-label="error"  style="color: red;"
                *ngIf="element.resultFailedFlag">error</mat-icon>
                <span style="color: red;font-size: 10px;"
                *ngIf="element.resultFailedFlag"> Error</span>

              </div>
          </td>
          </ng-container>


        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="col-sm-4" style="display: inline-block;"></tr>
        </table>
    </div>


    <div class="col-sm-12">
      <div mat-dialog-actions class="col" style="display: flex;justify-content: center;">
        <button class="btn btn-danger"  (click)="onNoClick()">Close</button>
      </div>
    </div>


   </div>

</div>
